
shadow.loader.set_load_start('shared9300');